/**
 * Check if data param is an object literal and has a prop key.
 * @param prop
 * @param data
 */
export function hasProp<T>(prop: keyof T, data: unknown): data is T {
    return typeof data === 'object' && data !== null && Object.hasOwn(data, prop);
}
